export const hasPropertyCheck = (item, key) => item !== null && typeof item === 'object' && item.hasOwnProperty(key);
